import { defineStore } from 'pinia';
import { ref } from 'vue';
import { fetchFavorites, addFavorite, removeFavorite } from '../api/account';

export const useFavoritesStore = defineStore('favorites', () => {
  const ids = ref<Set<string>>(new Set());
  const loaded = ref(false);

  async function load() {
    try {
      const products = await fetchFavorites(200);
      ids.value = new Set(products.map((p) => p.id));
    } catch {
      ids.value = new Set();
    } finally {
      loaded.value = true;
    }
  }

  function has(id: string) {
    return ids.value.has(id);
  }

  // Optimistic toggle; reverts on API failure.
  async function toggle(id: string) {
    const next = new Set(ids.value);
    const wasFav = next.has(id);
    if (wasFav) next.delete(id); else next.add(id);
    ids.value = next;
    try {
      if (wasFav) await removeFavorite(id); else await addFavorite(id);
    } catch {
      const revert = new Set(ids.value);
      if (wasFav) revert.add(id); else revert.delete(id);
      ids.value = revert;
    }
  }

  function clear() {
    ids.value = new Set();
    loaded.value = false;
  }

  return { ids, loaded, load, has, toggle, clear };
});
